let vimeoPlayerPromise;

export const loadVimeoPlayer = () => {
  if (!vimeoPlayerPromise) {
    vimeoPlayerPromise = import("@vimeo/player")
      .then(({ default: Player }) => Player)
      .catch((error) => {
        vimeoPlayerPromise = null;
        throw error;
      });
  }

  return vimeoPlayerPromise;
};

export const getVimeoEmbedUrl = (video, autoplay = false) => {
  const value = String(video ?? "").trim();
  const url = new URL(/^\d+$/.test(value) ? `https://vimeo.com/${value}` : value);

  if (
    !["https:", "http:"].includes(url.protocol) ||
    !["vimeo.com", "www.vimeo.com", "player.vimeo.com"].includes(url.hostname)
  ) {
    throw new Error("Invalid Vimeo video URL.");
  }

  const match = url.pathname.match(/^\/(?:video\/)?(\d+)(?:\/([a-zA-Z0-9]+))?\/?$/);

  if (!match) {
    throw new Error("Invalid Vimeo video URL.");
  }

  const embed = new URL(`https://player.vimeo.com/video/${match[1]}`);
  const privacyHash = url.searchParams.get("h") || match[2];

  if (privacyHash) {
    embed.searchParams.set("h", privacyHash);
  }

  embed.searchParams.set("autoplay", autoplay ? "1" : "0");
  embed.searchParams.set("title", "0");
  embed.searchParams.set("byline", "0");
  embed.searchParams.set("portrait", "0");
  embed.searchParams.set("playsinline", "1");
  embed.hash = url.hash;

  return embed.href;
};
